import React from 'react';
import styled from 'styled-components';

const Switch = ({ onThemeChange }) => {
	const themeHandler = (e) => {
		const isChecked = e.target.checked;
		console.log(isChecked);
		onThemeChange(isChecked);
	};

	return (
		<Container>
			{/* <input type="checkbox" name="checkbox" onChange={themeHandler} class="switch" /> */}
			<label class="switch">
				<input type="checkbox" onChange={themeHandler} />
				<span class="slider"></span>
			</label>
		</Container>
	);
};

const Container = styled.div`
	/* The switch - the box around the slider */
	/* The switch - the box around the slider */
	.switch {
		font-size: 11px;
		position: fixed;
		bottom: 1rem;
		right: 1rem;
		display: inline-block;
		width: 3.5em;
		height: 1em;
		z-index: 1000;
	}

	/* Hide default HTML checkbox */
	.switch input {
		opacity: 0;
		width: 0;
		height: 0;
	}

	/* The slider */
	.slider {
		position: absolute;
		cursor: pointer;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #000;
		border: 2px solid #ccc;
		transition: 0.4s;
		border-radius: 1px;
	}

	.slider:before {
		position: absolute;
		content: '';
		height: 1.3em;
		width: 1.2em;
		border-radius: 2px;
		left: 0.2em;
		bottom: 0.3em;
		background-color: #fff;
		border: 2px solid #000;
		transition: 0.1s;
	}

	input:checked + .slider {
		background-color: #fff;
		border: 2px solid #000;
	}

	input:focus + .slider {
		box-shadow: 0 0 1px #2196f3;
	}

	input:checked + .slider:before {
		transform: translateX(1.3em);
	}

	@media (max-width: 600px) {
		.switch {
			/* top: 1.5rem; */
		}
	}
`;

export default Switch;
